import { Wrap } from '@components';
import React from 'react';
import { Outlet } from 'react-router-dom';

const AiChatPage = () => {
  return (
    <Wrap>
      <Outlet />
    </Wrap>
  );
};

export default AiChatPage;
